// extracted by mini-css-extract-plugin
module.exports = {"absolute-center":"onfido-sdk-ui-Complete-absolute-center","wrapper":"onfido-sdk-ui-Complete-wrapper","icon":"onfido-sdk-ui-Complete-icon"};